import { apiClient } from './apiClient';

export type Contract = {
  id: string;
  contractNumber: number;
  contractCode: string;
  code: string;
  title: string;
  description?: string | null;
  companyId: string;
  companyName: string;
  salesProductId?: string | null;
  salesProductName?: string | null;
  status: string;
  startDateUtc: string;
  endDateUtc: string;
  responseSlaId?: string | null;
  responseSlaName?: string | null;
  resolutionSlaId?: string | null;
  resolutionSlaName?: string | null;
  calendarId?: string | null;
  calendarName?: string | null;
  ownerUserId?: string | null;
  ownerUserName?: string | null;
  amount?: number | null;
  notes?: string | null;
  welcomeEnabled: boolean;
  welcomeEmailTemplateId?: string | null;
  csatEnabled: boolean;
  csatSurveyFormId?: string | null;
  npsEnabled: boolean;
  npsSurveyFormId?: string | null;
  npsFrequency?: string | null;
  daysUntilEnd?: number | null;
  createdAtUtc: string;
  updatedAtUtc: string;
};

export type ContractUpsertPayload = {
  code?: string;
  title: string;
  description?: string;
  companyId: string;
  salesProductId?: string;
  status: string;
  startDateUtc: string;
  endDateUtc: string;
  responseSlaId?: string;
  resolutionSlaId?: string;
  calendarId?: string;
  ownerUserId?: string;
  amount?: number;
  notes?: string;
  welcomeEnabled: boolean;
  welcomeEmailTemplateId?: string | null;
  csatEnabled: boolean;
  csatSurveyFormId?: string | null;
  npsEnabled: boolean;
  npsSurveyFormId?: string | null;
  npsFrequency?: string | null;
};

export type ContractListResult = {
  items: Contract[];
  totalCount: number;
  page: number;
  pageSize: number;
};

export async function listContracts(params?: {
  companyId?: string;
  status?: string;
  activeOnly?: boolean;
  search?: string;
  page?: number;
  pageSize?: number;
}): Promise<ContractListResult> {
  const response = await apiClient.get<ContractListResult>('/v1/commercial/contracts', { params });
  return response.data;
}

export async function listActiveContractsByCompany(companyId: string): Promise<Contract[]> {
  const response = await apiClient.get<Contract[]>(
    `/v1/commercial/contracts/by-company/${companyId}`,
  );
  return response.data;
}

export async function createContract(payload: ContractUpsertPayload): Promise<Contract> {
  const response = await apiClient.post<Contract>('/v1/commercial/contracts', payload);
  return response.data;
}

export async function updateContract(id: string, payload: ContractUpsertPayload): Promise<Contract> {
  const response = await apiClient.put<Contract>(`/v1/commercial/contracts/${id}`, payload);
  return response.data;
}

export async function deleteContract(id: string): Promise<void> {
  await apiClient.delete(`/v1/commercial/contracts/${id}`);
}
